function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbahn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    style: {
      fill: "#006bb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49715,3.1728V14.27968c0,2.943,1.1161,4.43988,3.09511,4.43988,2.02979,0,3.1459-1.42083,3.1459-4.43988V3.1728h3.85643V14.026c0,5.277-2.66378,7.78869-7.12918,7.78869-4.313,0-6.85022-2.38482-6.85022-7.83948V3.1728Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbahn);
export default __webpack_public_path__ + "static/media/ubahn.9471b6d6e4cee3f726f15f656551e37f.svg";
export { ForwardRef as ReactComponent };